var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.652 10.757a.45.45 0 01-.704 0L5.28 7.407a.45.45 0 01.352-.73h5.333a.45.45 0 01.353.73l-2.667 3.35z",
    fill: "#9598AB"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjUxOTcgMTAuNzU2OUM4LjQ3MTgyIDEwLjk4MzMgOC4xMjc5OSAxMC45ODMzIDcuOTQ3ODMgMTAuNzU2OUw1LjI4MTIzIDcuNDA3MTJDNS4wNDY1NCA3LjExMjMgNS4yNTY0NyA2LjY3Njg1IDUuNjMzMyA2LjY3Njg1TDEwLjk2NjUgNi42NzY4NUMxMS4zNDMzIDYuNjc2ODUgMTEuNTUzMyA3LjExMjMgMTEuMzE4NiA3LjQwNzEyTDguNjUxOTcgMTAuNzU2OVoiIGZpbGw9IiM5NTk4QUIiLz4KPC9zdmc+Cg==";
export { SvgSelectArrow as ReactComponent };